import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/System/Date_Time/SuccessBox';
import DateTable from 'components/Web_User_Interface/1080p_Series/System/Date_Time/dateTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  DateTable,
  BreadCrumbs,
  SEOHelmet,
  React
};